"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    exportSettings: {
        path: "/settings/data/exports",
    },
    arcGISExports: {
        path: "/settings/data/exports/arcgis",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwb3J0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvZXhwb3J0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBc0M7QUFFekIsUUFBQSxNQUFNLEdBQUcsSUFBQSxtQkFBVyxFQUFDO0lBQ2hDLGNBQWMsRUFBRTtRQUNkLElBQUksRUFBRSx3QkFBd0I7S0FDL0I7SUFDRCxhQUFhLEVBQUU7UUFDYixJQUFJLEVBQUUsK0JBQStCO0tBQ3RDO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgYnVpbGRSb3V0ZXMgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY29uc3Qgcm91dGVzID0gYnVpbGRSb3V0ZXMoe1xuICBleHBvcnRTZXR0aW5nczoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2RhdGEvZXhwb3J0c1wiLFxuICB9LFxuICBhcmNHSVNFeHBvcnRzOiB7XG4gICAgcGF0aDogXCIvc2V0dGluZ3MvZGF0YS9leHBvcnRzL2FyY2dpc1wiLFxuICB9LFxufSk7XG4iXX0=